(function() {
  'use strict';

  angular.module('ringbaPortal').component('ivrTreeLevel', {
    bindings: {
      ivrTree: '<',
      collapseAll: '<',
      level: '<',
      depth: '<',
      onAddNodeToTree: '<',
      onRemoveNode: '<',
      onUpdateNode: '<',
      updateConnections: '<',
      nodeTypes: '<',
      updateLink: '<',
      isSelectModeActive: '<', // This is for GOTO node selection
      activateSelectMode: '<', // This is for GOTO node selection
      selectGotoDestinationNode: '<', // This is for GOTO node selection
      highlightNode: '<', // This is for GOTO node selection
      uploadAudioFile: '<',
      ivrFiles: '<'
    },
    controller: ivrTreeLevelController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/ivr/ivr-tree-level.view.html'
  });

  function ivrTreeLevelController(
  ) {
    'ngInject';
    const vm = this;

    vm.$onChanges = onChanges;

    function onChanges(changes) {
      if (changes.level) {
        vm.nodes = angular.copy(vm.level);
      }
    }
  }
})();
